module.exports = __webpack_public_path__ + "img/conocenos2.64c7b211.webp";